"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONDUCT_STOCKTAKE = void 0;
var CONDUCT_STOCKTAKE = {
  BUTTON__NEXT_STEP: 'conductStocktake-button-nextStep',
  BUTTON__PREV_STEP: 'conductStocktake-button-prevStep',
  WAREHOUSE: {
    BUTTON__WAREHOUSE: 'conductStocktakeWarehouse-button-selectWarehouse'
  },
  STOCKTAKING: {
    INPUT__SEARCH: 'conductStocktakeStocktaking-input-search',
    INPUT__INVENTORY: 'conductStocktakeStocktaking-input-productInventory',
    BUTTON__ADD_STOCK: 'conductStocktakeStocktaking-button-addNewStock',
    BUTTON__SELECT: 'conductStocktakeStocktaking-button-selectProduct',
    BUTTON__DESELECT: 'conductStocktakeStocktaking-button-deselectProduct',
    BUTTON__OPTIONS: 'conductStocktakeStocktaking-button-moreOptions',
    BUTTON__EDIT_STOCK: 'conductStocktakeStocktaking-button-editStock',
    EDIT_STOCK_MODAL: {
      INPUT__BATCH_CODE: 'conductStocktakeEditStockModal-input-batchCode',
      INPUT__EXPIRY_DATE: 'conductStocktakeEditStockModal-input-expiryDate',
      INPUT__COGS: 'conductStocktakeEditStockModal-input-cogs',
      BUTTON__SELECT_LOCATION: 'conductStocktakeEditStockModal-button-selectLocation',
      BUTTON__CANCEL: 'conductStocktakeEditStockModal-button-cancel',
      BUTTON__SAVE: 'conductStocktakeEditStockModal-button-save',
      TEXTAREA__NOTE: 'conductStocktakeEditStockModal-textarea-note'
    },
    ADD_STOCK_MODAL: {
      INPUT__BATCH_CODE: 'conductStocktakeAddStockModal-input-batchCode',
      INPUT__EXPIRY_DATE: 'conductStocktakeAddStockModal-input-expiryDate',
      INPUT__COGS: 'conductStocktakeAddStockModal-input-cogs',
      BUTTON__SELECT_PRODUCT: 'conductStocktakeAddStockModal-button-selectProduct',
      BUTTON__SELECT_LOCATION: 'conductStocktakeAddStockModal-button-selectLocation',
      BUTTON__CANCEL: 'conductStocktakeAddStockModal-button-cancel',
      BUTTON__SAVE: 'conductStocktakeAddStockModal-button-addStock'
    }
  },
  OVERVIEW: {
    TEXT__WAREHOUSE_NAME: 'conductStocktakeOverview-p-warehouseName',
    TEXT__PRODUCT_NAME: 'conductStocktakeOverview-span-productName',
    BUTTON__EXPAND: 'conductStocktakeOverview-button-expandList',
    BUTTON__EDIT_WAREHOUSE: 'conductStocktakeOverview-button-editWarehouse',
    BUTTON__EDIT_PRODUCTS: 'conductStocktakeOverview-button-editProducts',
    BUTTON__ADD_USER: 'conductStocktakeOverview-button-addUser',
    BUTTON__REMOVE_USER: 'conductStocktakeOverview-button-removeUser',
    INPUT__USER_NAME: 'conductStocktakeOverview-input-userName',
    TEXTAREA__NOTE: 'conductStocktakeOverview-textarea-note'
  }
};
exports.CONDUCT_STOCKTAKE = CONDUCT_STOCKTAKE;